import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const removeCompany = ({ directID, tcID }) => {
  return axios.delete(`/api/directs/${directID}/companies/${tcID}`);
};

export const useRemoveCompany = (type, onCompanyRemoval) => {
  const { enqueueSnackbar } = useSnackbar();
  const snackMessage =
    type === 'buyer'
      ? 'Buyer successfully removed from a direct'
      : 'Supplier successfully removed from a direct';

  return useMutation({
    mutationFn: removeCompany,
    onSuccess: () => {
      enqueueSnackbar(snackMessage, {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      onCompanyRemoval();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
